import { render, staticRenderFns } from "./floatingBtn.vue?vue&type=template&id=499c4c32&scoped=true"
import script from "./floatingBtn.vue?vue&type=script&lang=js"
export * from "./floatingBtn.vue?vue&type=script&lang=js"
import style0 from "./floatingBtn.vue?vue&type=style&index=0&id=499c4c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499c4c32",
  null
  
)

export default component.exports